/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { RelationalTariffProfileBaseDto } from './RelationalTariffProfileBaseDto';
import type { ThirdPartyCardDto } from './ThirdPartyCardDto';
import type { TranslatableEnumDto } from './TranslatableEnumDto';
export type ThirdPartyTicketBaseDto = {
    /**
     * Ticket state.
     */
    state: ThirdPartyTicketBaseDto.state;
    /**
     * Price of the ticket.
     */
    ticketPrice: number;
    /**
     * Provider identifier.
     */
    providerId: number;
    /**
     * Date from which the ticket is valid.
     */
    validFrom: string;
    /**
     * Date until which the ticket is valid.
     */
    validTo: string;
    /**
     * Third party card.
     */
    card: ThirdPartyCardDto;
    /**
     * Zone from.
     */
    zoneFrom: TranslatableEnumDto;
    /**
     * Zone to.
     */
    zoneTo: TranslatableEnumDto;
    /**
     * Customer profile.
     */
    customerProfile: TranslatableEnumDto;
    /**
     * Tariff profile.
     */
    tariffProfile: RelationalTariffProfileBaseDto;
};
export namespace ThirdPartyTicketBaseDto {
    /**
     * Ticket state.
     */
    export enum state {
        CANCELLED = 'CANCELLED',
        EXPIRED = 'EXPIRED',
        ACTIVE = 'ACTIVE',
        FUTURE = 'FUTURE',
    }
}

